// @flow
import { injectIntl, intlShape } from 'react-intl';

import { Background } from './style';
import Button from './button/component';
import Icon from './icon/component';
import messages from '~/core/domains/schedule/intl';
import PropTypes from 'prop-types';
import * as React from 'react';
import { scheduleModesEnum } from '~/core/constants/schedule';

ControlPanel.propTypes = {
    areChangesMade: PropTypes.bool.isRequired,
    attemptSaveSchedule: PropTypes.func.isRequired,
    changeMode: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    intl: intlShape,
    scheduleMode: PropTypes.string.isRequired,
    showSaveButton: PropTypes.bool,
    sideMarginWidth: PropTypes.number.isRequired,
    undoAll: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired
};

function ControlPanel({
    areChangesMade,
    attemptSaveSchedule,
    changeMode,
    height,
    intl: { formatMessage },
    scheduleMode,
    showSaveButton = true,
    sideMarginWidth,
    undoAll,
    width
}) {
    const size = Math.floor(height * 0.8);
    const buttonWidth = sideMarginWidth * 2;
    const relativeIconRightStart = width - sideMarginWidth - buttonWidth * (showSaveButton ? 2.2 : 1.2);

    return (
        <g>
            <Background height={height} width={width} />
            <Icon
                changeMode={() => changeMode(scheduleModesEnum.ADD_EVENT)}
                isSelected={scheduleMode === scheduleModesEnum.ADD_EVENT}
                size={size}
                type="PLUS"
                xPos={relativeIconRightStart - size * 3.6}
                yPos={height / 2}
            />
            <Icon
                changeMode={() => changeMode(scheduleModesEnum.COPY_DAY)}
                isSelected={scheduleMode === scheduleModesEnum.COPY_DAY}
                size={size}
                type="COPY"
                xPos={relativeIconRightStart - size * 2.3}
                yPos={height / 2}
            />
            <Icon
                changeMode={() => changeMode(scheduleModesEnum.DELETE_EVENT)}
                isSelected={scheduleMode === scheduleModesEnum.DELETE_EVENT}
                size={size}
                type="MINUS"
                xPos={relativeIconRightStart - size}
                yPos={height / 2}
            />
            {showSaveButton && (
                <Button
                    data-qa="schedule-save"
                    height={size}
                    isDisable={!areChangesMade}
                    onClick={attemptSaveSchedule}
                    text={formatMessage(messages.save)}
                    width={buttonWidth}
                    xPos={width - sideMarginWidth - buttonWidth * 0.5}
                    yPos={height / 2}
                />
            )}
            <Button
                data-qa="schedule-undo-all"
                height={size}
                isDisable={!areChangesMade}
                onClick={undoAll}
                text={formatMessage(messages.undoAll)}
                width={buttonWidth}
                xPos={width - sideMarginWidth - buttonWidth * (showSaveButton ? 1.7 : 0.5)}
                yPos={height / 2}
            />
        </g>
    );
}

export default injectIntl(ControlPanel);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/component.js